/**
 * Generuje wartość dla parametru action w Turnstile na podstawie hosta i akcji.
 * Format: {host-bez-empikfoto-z-kropkami-zamienionymi-na-kreski}-{akcja}
 *
 * @param action - Akcja: 'login', 'register', 'forgot-password'
 * @returns String w formacie np. "www-dev-pl-login" (max 32 znaki)
 *
 * @example
 * // dla www.dev.empikfoto.pl i action='login'
 * generateTurnstileAction('login') // "www-dev-pl-login"
 *
 * @example
 * // dla www-cz.dev.empikfoto.pl i action='register'
 * generateTurnstileAction('register') // "www-cz-dev-pl-register"
 */
export function generateTurnstileAction(action: 'login' | 'register' | 'forgot-password'): string {
  const hostname = window.location.hostname;

  // Usuń "empikfoto" z hostname
  const hostnameWithoutEmpikfoto = hostname.replace(/empikfoto\./g, '');

  // Zamień kropki na kreski
  const hostnameFormatted = hostnameWithoutEmpikfoto.replace(/\./g, '-');

  // Połącz z akcją
  const result = `${hostnameFormatted}-${action}`;

  // Cloudflare ma limit 32 znaków
  return result.substring(0, 32);
}
